import React, { useState, useEffect } from "react";
import PopupForm from "./PopupForm.js";
import ServiceNav from "../components/ServiceNav";
import ServiceHero from "../components/ServiceHero";
import { FiCheckCircle, FiPhoneCall, FiBarChart2, FiTarget } from "react-icons/fi";
import { ServiceCta } from "../components/CtaSystem";
import "./CallAnalytics.css";

const CallAnalytics = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="call-analytics-container">
      {/* Hero Section */}
      <ServiceHero
        kicker="SERVICE 05"
        title="Call Analytics"
        description="Analyze call data, monitor trends, and enhance customer interactions."
        bgImage="/service5.png"
        onConnectClick={() => setIsPopupOpen(true)}
      />

      {/* About Call Analytics */}
      <section className="about-call-section">
        <div className="about-content">
          <div className="vector-image">
            <img 
              src="./call-img.png" 
              alt="Call Analytics Vector" 
            />
          </div>
          <div className="about-text">
            <h2>What is Call Analytics?</h2>
            <p>
              Call Analytics provides data-driven insights from customer interactions to improve call center performance, enhance customer satisfaction, and optimize sales strategies.
            </p>
            <ul>
              <li><FiCheckCircle className="check-icon" /> Call Tracking & Monitoring</li>
              <li><FiCheckCircle className="check-icon" /> Speech & Sentiment Analysis</li>
              <li><FiCheckCircle className="check-icon" /> AI-driven Insights & Automation</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features-section">
        <h2 className="section-title">Why Choose Our Call Analytics Solution?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon"><FiPhoneCall /></span>
            <h3>Call Tracking</h3>
            <p>Monitor and analyze call data in real time.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon"><FiBarChart2 /></span>
            <h3>Performance Insights</h3>
            <p>Identify trends and optimize communication strategies.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon"><FiTarget /></span>
            <h3>Customer Engagement</h3>
            <p>Enhance user experience with AI-driven analytics.</p>
          </div>
        </div>
      </section>

      {/* Service CTA */}
      <ServiceCta
        eyebrow="CALL ANALYTICS"
        heading="Extract Actionable Audio Insights & Boost Performance"
        primaryBtnText="Connect Now!"
        onPrimaryClick={() => setIsPopupOpen(true)}
        secondaryBtnText="Contact Us"
        secondaryBtnLink="/contact-us"
      />

      {/* Service Navigation */}
      <ServiceNav currentPath="/call-analytics" />

      {/* Popup Form Component */}
      <PopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
};

export default CallAnalytics;
